
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cases/prototyping/page/[id]",
      function () {
        return require("private-next-pages/cases/prototyping/page/[id].tsx");
      }
    ]);
  